import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { alchemy } from "../utils/alchemy";

function Home() {
  const [latestBlocks, setLatestBlocks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchLatestBlocks() {
      try {
        const blockNumber = await alchemy.core.getBlockNumber();
        const blocks = [];

        for (let i = 0; i < 10; i++) {
          const block = await alchemy.core.getBlock(blockNumber - i);
          blocks.push(block);
        }

        setLatestBlocks(blocks);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching blocks:", error);
        setLoading(false);
      }
    }

    fetchLatestBlocks();
  }, []);

  if (loading) {
    return <div className="loading">Loading latest blocks...</div>;
  }

  return (
    <div className="page">
      <h1>Latest Blocks</h1>
      <div className="blocks-list">
        {latestBlocks.map((block) => (
          <div key={block.number} className="block-card">
            <Link to={`/block/${block.number}`} className="block-number">
              Block #{block.number}
            </Link>
            <div className="block-meta">
              <span>Transactions: {block.transactions.length}</span>
              <span>Gas Used: {parseInt(block.gasUsed._hex, 16).toLocaleString()}</span>
              <span>{new Date(block.timestamp * 1000).toLocaleString()}</span>
            </div>
            <div className="block-miner">
              Miner: <Link to={`/address/${block.miner}`}>{block.miner}</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Home;
